import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LegalNavId, LegalNavState } from "../types/index.js";

const initialState: LegalNavState = { id: undefined };

const legalNavSlice = createSlice({
  name: "legalNav",
  initialState,
  reducers: {
    toggleLegalNav: (
      state,
      {
        payload: { legalNavId },
      }: PayloadAction<{ legalNavId: LegalNavId | undefined }>,
    ) => {
      state.id = legalNavId;
    },
  },
});

export const { toggleLegalNav } = legalNavSlice.actions;

export default legalNavSlice.reducer;
